import React from 'react'
import Cards from 'react-credit-cards'
import 'react-credit-cards/es/styles-compiled.css'

type Props = {
    cvv: string
    expiresAt: string
    holder: string
    number: string
}

export const Cartao: React.FC<Props> = ({
    cvv = '',
    holder = '',
    number = '',
    expiresAt = '',
}) => {
    return (
        <Cards
            cvc={cvv}
            expiry={expiresAt.split('-').reverse().join('/')}
            name={holder}
            number={number}
            placeholders={{
                name: 'Nome do Titular',
            }}
            locale={{
                valid: 'Cartão válido',
            }}
        />
    )
}
